import * as React from 'react';
import { ErrorState } from '@leagueplatform/web-common-components';
import { Box } from '@leagueplatform/genesis-core';

function ErrorPage() {
  return (
    <Box
      css={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <ErrorState headingId="SORRY_WE_CANT_FIND_PAGE" />
    </Box>
  );
}

export default ErrorPage;
